import StatusDot from '@/components/ui/StatusDot.tsx';
import { RegistrationStatus } from '@/features/dashboard/tours/types/RegistrationStatus.ts';
import { registrationDetailsTsUtils } from '@/features/dashboard/tours/types/RegistrationDetails.ts.utils.ts';

/**
 * Stan zapisów przy nazwie wyjazdu. Etykieta dostaje przedrostek, bo obok stoi
 * już stan samego wyjazdu — samo „Otwarte” nie mówi, czego dotyczy.
 */
const RegistrationStatusIndicator = ({
  status,
}: {
  status: RegistrationStatus;
}) => (
  <StatusDot
    tone={registrationDetailsTsUtils.getTone(status)}
    label={`Zapisy ${registrationDetailsTsUtils.getLabel(status).toLowerCase()}`}
  />
);

export default RegistrationStatusIndicator;
